import { Flex, Box } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";

export default function CommandEditorView({
  disableSave,
  onSave,
  onClose,
  onBack,
  recorder,
  commandPreview,
  inputFields
}) {
  return (
    <Flex flexDirection="column" height="100%">
      <NavigationBar
        headingKey="command.editor.heading"
        actionButton={{
          labelKey: "buttons.save",
          onClick: onSave,
          disabled: disableSave
        }}
        onBack={onBack}
        onClose={onClose}
      />
      <Flex p="24px" flex="1 1 auto">
        <Box width="264px" mr="48px" height="100%">
          {recorder}
        </Box>
        <Box>
          {inputFields}
          <Box mt="33px">{commandPreview}</Box>
        </Box>
      </Flex>
    </Flex>
  );
}
